import { isServerSide } from '@/helpers';
import { serverSideAxiosInstance } from '@/utils/serverSideAxiosClientWithInterceptor';
import axiosInstanceFromComponent from '@/components/AxiosInterceptorComponent';
import { AxiosInstance } from 'axios';

export const getAxiosInstance = (): AxiosInstance => {
  return isServerSide() ? serverSideAxiosInstance : axiosInstanceFromComponent;
};
